module.exports = __webpack_public_path__ + "img/ISO-pic2.e9c137ac.png";